
<div @fastFadeInOut *ngIf="mouseMoved" class="top-background-transition background-transition"></div>
<div @fastFadeInOut *ngIf="mouseMoved" class="bottom-background-transition background-transition"></div>